import { render, staticRenderFns } from "./OrderWidget.vue?vue&type=template&id=3c0a69d0&"
import script from "./OrderWidget.vue?vue&type=script&lang=js&"
export * from "./OrderWidget.vue?vue&type=script&lang=js&"
import style0 from "./OrderWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0a69d0')) {
      api.createRecord('3c0a69d0', component.options)
    } else {
      api.reload('3c0a69d0', component.options)
    }
    module.hot.accept("./OrderWidget.vue?vue&type=template&id=3c0a69d0&", function () {
      api.rerender('3c0a69d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/OrderWidget.vue"
export default component.exports